import 'normalize.css';
import '../scss/index.scss';
// @ts-ignore
import patientBackgroundImage from '../static/img/patient_background.jpg';
// @ts-ignore
import referringBackgroundImage from '../static/img/referring_background.jpg';

const warning = document.getElementById('warning-msg');

const query = window.location.search.substring(1);
const queryParameters = query.split('&');
for (let index = 0; index < queryParameters.length; index++) {
	const element = queryParameters[index];
	const pair = element.split('=');
	if (pair[0] === 'type') {
		if (pair[1] === 'external') {
			const rand = Math.floor(Math.random() * 2);

			if (rand === 0) {
				document.body.style.backgroundImage =
					'url(' + patientBackgroundImage + ')';
			} else {
				document.body.style.backgroundImage =
					'url(' + referringBackgroundImage + ')';
			}
		} else if (pair[1] === 'patient') {
			document.body.style.backgroundImage =
				'url(' + patientBackgroundImage + ')';
		} else if (pair[1] === 'referring') {
			document.body.style.backgroundImage =
				'url(' + referringBackgroundImage + ')';
		}
	}
}

document.addEventListener('keyup', event => {
	if (event && event.getModifierState('CapsLock')) {
		warning.style.display = 'block';
	} else {
		warning.style.display = 'none';
	}
});
